import {observer} from 'mobx-react-lite'
import {AgGridReactProps, AgGridReact} from 'ag-grid-react'
import {cx} from '@emotion/css'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-material.css'
import './ocAgGridStyles.css'

// TODO FIX OC AG GRID
// import {ModuleRegistry, AllCommunityModule, provideGlobalGridOptions} from 'ag-grid-community'

// ModuleRegistry.registerModules([AllCommunityModule])
// provideGlobalGridOptions({
//     theme: 'legacy'
// })

export const AgGridDefaultClassName = 'ag-theme-material'
export const OcAgGridClassNamePrefix = 'oc-ag-grid'
export const OcAgGridDefaultClassName = cx(OcAgGridClassNamePrefix, AgGridDefaultClassName)
export const getOcAgGridClassName = (componentPrefix: string, baseClassName = OcAgGridDefaultClassName) =>
    cx(componentPrefix, baseClassName)

export const _OcAgGrid = <TData,>(props: AgGridReactProps<TData>) => {
    const usingOwnIds = !!(props.getRowId || props.gridOptions?.getRowId)
    const onGridReady = props.onGridReady ?? props.gridOptions?.onGridReady
    const rowData = props.rowData ?? props.gridOptions?.rowData
    const rowModelType = props.rowModelType ?? props.gridOptions?.rowModelType
    const onFirstDataRendered = props.onFirstDataRendered ?? props.gridOptions?.onFirstDataRendered
    const onGridSizeChanged = props.onGridSizeChanged ?? props.gridOptions?.onGridSizeChanged

    // TOMAS check that switching between infinite and finite mode works
    const [rowData2, datasource] =
        usingOwnIds && rowModelType === 'infinite' && props.datasource
            ? [undefined, props.datasource]
            : [rowData, undefined]

    /*React.useEffect(() => {
        if (gridApi && usingOwnIds) {
            if (rowData?.length) {
                gridApi.setRowData(rowData)
            } else if (rowModelType !== 'infinite') {
                gridApi.setRowData([])
            }
        }
    }, [rowData, rowData?.length, gridApi, usingOwnIds, rowModelType])*/

    return (
        <AgGridReact<TData>
            className={OcAgGridDefaultClassName}
            suppressDragLeaveHidesColumns={true}
            tooltipShowDelay={0}
            enableCellTextSelection={true}
            containerStyle={{
                display: 'block',
                width: '100%',
                height: '100%'
            }}
            {...props}
            rowData={rowData2}
            datasource={datasource}
            onGridReady={onGridReady}
            onGridSizeChanged={params => {
                if (!params.api.isDestroyed()) onGridSizeChanged?.(params)
            }}
            onFirstDataRendered={params => {
                if (!params.api.isDestroyed()) onFirstDataRendered?.(params)
            }}
        />
    )
}

export const OcAgGrid = observer(_OcAgGrid)
